/* eslint-disable max-len */
import { Plug } from 'SharedDir/router/helpers';
import { RouteRecordRaw } from 'vue-router';

const ServicesList = () =>
  import(/* webpackChunkName: "PublicServiceList" */ 'PortalDir/modules/Services/pages/List.vue');

const ServicesView = () =>
  import(
    /* webpackChunkName: "PublicServicesView" */ 'PortalDir/modules/Services/pages/ServiceView.vue'
  );

const routes: Array<RouteRecordRaw> = [
  {
    path: '/services/',
    name: 'services',
    component: ServicesList,
  },
  {
    path: '/services/:serviceId',
    name: 'service-view',
    component: ServicesView,
    props: true,
  },
];

export default routes;
